import * as RadixRadioGroup from "@radix-ui/react-radio-group";
import { withClassName } from "../../utils";

const Root = RadixRadioGroup.Root;

const Item = withClassName(
  RadixRadioGroup.Item,
  "cursor-pointer flex relative items-center justify-center font-medium text-gray-1200 h-6 w-6 rounded-full bg-white disabled:bg-gray-400 disabled:pointer-events-none border border-default outline-none focus-visible:ring-2 ring-offset-1 ring-theme-accent active:scale-95 transition duration-200 ease-in-out data-[state=unchecked]:hover:bg-gray-300 data-[state=checked]:bg-theme-accent data-[state=checked]:border-theme-accent",
);

const Indicator = withClassName(
  RadixRadioGroup.Indicator,
  "h-3 w-3 rounded-full transition duration-150 ease-in-out bg-white",
);

export const RadioGroup = {
  Root,
  Item,
  Indicator,
};
